<template>
  <AtomsConsumerLink :url="`/shop/detail/${store.document_id}`">
    <div :class="$style.shop_item">
      <div :class="$style.shop_image">
        <AtomsConsumerImage :src="storePcImage" :alt="store.store_name" :class="$style.pc_image" :width="620" />
        <AtomsConsumerImage :src="storeSpImage" :alt="store.store_name" :class="$style.sp_image" :width="768" />
      </div>
      <div :class="$style.shop_content">
        <div
          v-if="store.label_text"
          :class="$style.shop_label"
          :style="{ color: store.label_color, backgroundColor: store.label_bg_color || 'white' }"
        >
          {{ store.label_text }}
        </div>
        <div :class="$style.shop_content_head">
          <p :class="$style.shop_store_name">{{ store.store_name }}</p>
        </div>
        <div :class="$style.contact">
          <div :class="[$style.container, $style.address]">
            <p>〒{{ store.post_code }}</p>
            <p :class="$style.shop_address" v-text="store.address"></p>
          </div>
          <p v-if="store.hours" :class="[$style.container, $style.hours]"> 営業時間： {{ store.hours }} </p>
        </div>
      </div>
    </div>
  </AtomsConsumerLink>
</template>

<script setup lang="ts">
import { StoreFragment } from "~/types/type.generated"

const props = defineProps<{ store: StoreFragment }>()

const storePcImage = computed(() => {
  const store = props.store
  return store.image && store.image[0] ? store.image[0] : "images/common/no-image.png"
})

const storeSpImage = computed(() => {
  const store = props.store
  return store.image && store.image[0] ? store.image[0] : "images/common/no-image.png"
})
</script>

<style scoped module lang="scss">
.shop_item {
  display: flex;
  flex-flow: column;
  cursor: pointer;
  background-color: $primary-10;
  border-radius: 0.375rem;
  height: 100%;
  .shop_image {
    position: relative;
    img {
      aspect-ratio: 700 / 455;
      width: 100%;
      object-fit: cover;
      border-radius: 0.375rem 0.375rem 0 0;
    }
    .pc_image {
      display: none;
      @include md {
        display: block;
      }
    }
    .sp_image {
      display: block;
      @include md {
        display: none;
      }
    }
  }
  .shop_content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    .shop_label {
      display: inline-block;
      padding: 0 0.75rem;
      border-radius: 0.125rem;
      font-size: $font-size-10;
      white-space: nowrap;
      @include md {
        font-size: $font-size-13;
      }
    }
    .shop_content_head {
      display: flex;
      align-items: flex-start;
      .shop_store_name {
        font-size: $font-size-14;
        color: $primary;
        @include md {
          font-size: $font-size-18;
        }
      }
    }
    .contact {
      font-size: $font-size-12;
      @include md {
        font-size: $font-size-15;
      }
    }
    .shop_detail {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 11px;
      @include md {
        gap: 10px;
      }
      .button {
        @include md {
          font-size: $font-size-13;
        }
      }
    }
  }
}
</style>
